import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); } catch {}
    setDone(true); setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm">
        {done ? (
          <div className="text-center space-y-4">
            <MailCheck className="h-14 w-14 text-emerald-600 dark:text-emerald-400 mx-auto" />
            <h2 className="font-heading text-3xl">Check your email</h2>
            <p className="text-muted-foreground text-sm">If that email is registered, a reset link has been sent. It expires in 1 hour.</p>
            <Link to="/admin/login"><Button variant="outline" className="rounded-full">Back to sign in</Button></Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <div>
              <h2 className="font-heading text-4xl font-semibold">Reset password</h2>
              <p className="text-muted-foreground text-sm mt-1">We'll email you a secure reset link.</p>
            </div>
            <div>
              <Label>Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" required />
            </div>
            <Button type="submit" disabled={loading} className="w-full rounded-full h-11" data-testid="forgot-submit">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send Reset Link"}
            </Button>
            <Link to="/admin/login" className="block text-center text-sm text-muted-foreground hover:text-primary">Back to sign in</Link>
          </form>
        )}
      </div>
    </div>
  );
}
